import React from 'react';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Responsive from 'src/components/responsive/Responsive';
import { Flex } from 'src/components/flex';
import TabsBar from 'src/components/tabs-bar';
import { conversationTabs, type EConversationTab } from 'src/pages/landlord/conversations/context/types';
import Checkbox from '@mui/material/Checkbox';
import type { IConversation } from 'src/api/landlord-messages-api';
import type { IConversationMatchWithChannel } from 'src/pages/landlord/conversations/context/types';
import styles from 'src/pages/landlord/conversations/components/navigation/ConversationsNavigation.module.css';

type Props = {
    tab: EConversationTab;
    setTab: (tab: EConversationTab) => void;
    filteredConversations: IConversation[];
    selectedConversations: Array<IConversation | IConversationMatchWithChannel>;
    setSelectedConversations: React.Dispatch<React.SetStateAction<Array<IConversation | IConversationMatchWithChannel>>>;
};

export default function ConversationsNavigation({
    tab,
    setTab,
    filteredConversations,
    selectedConversations,
    setSelectedConversations,
}: Props) {

    const hasConversations = filteredConversations.length > 0;

    // Check if all filtered conversations are selected
    const allSelected = hasConversations &&
        filteredConversations.every((conversation) => {
            return selectedConversations.some((
                selectedConversation
            ) => selectedConversation.lead_uuid === conversation.lead_uuid);
        });

    // Select/deselect all filtered conversations
    const selectAll = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();

        if (allSelected) {
            // Deselect all filtered conversations
            setSelectedConversations(prev => {
                return prev.filter((conversation) => {
                    return !filteredConversations.some((
                        filteredConversation
                    ) => filteredConversation.lead_uuid === conversation.lead_uuid);
                });
            });
        } else {
            // Select all filtered conversations
            setSelectedConversations(prev => {
                const newSelectedConversations = filteredConversations.filter((conversation) => {
                    return !prev.some((
                        selectedConversation
                    ) => selectedConversation.lead_uuid === conversation.lead_uuid);
                });

                return [...prev, ...newSelectedConversations];
            });
        }
    };

    return (
        <TabsBar
            leading={(
                <Responsive desktop>
                    <Flex className={styles.checkboxWrapper}>
                        <Checkbox
                            checked={allSelected}
                            onClick={selectAll}
                            className={styles.checkbox}
                        />
                    </Flex>
                </Responsive>
            )}
        >
            <Tabs
                variant="scrollable"
                scrollButtons="auto"
                value={tab}
                className={styles.tabs}
            >
                {conversationTabs.map((_tab) => (
                    <Tab
                        key={_tab}
                        label={_tab}
                        value={_tab}
                        onClick={() => setTab(_tab)}
                        iconPosition="end"
                        className={styles.tabItem}
                    />
                ))}
            </Tabs>
        </TabsBar>
    );
}
